export const filterOptionFunc = (inputVal, option) => {
  return option.label.includes(inputVal);
};
